import BusinessLinesEntry from './business-lines-entry';

export default class BusinessLinesEntryDesktop extends BusinessLinesEntry {
    constructor(...args) {
        super(...args);
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/business-lines/entry/business-lines-entry.desktop.js